import React from 'react'
export const FEATURES = {
	// HOST HEALTHCARE FEATURES

	// "care-activation": React.lazy(() => import("~/features/care-activation")),
	'care-timecards': React.lazy(() => import('~/features/care-timecards')),

	'care-profile': React.lazy(() => import('~/features/care-profile')),
	'care-popular-cities': React.lazy(() => import('~/features/care-popular-cities')),
	'care-find-job': React.lazy(() => import('~/features/care-find-job')),
	'care-suggested-jobs': React.lazy(() => import('~/features/care-suggested-jobs')),
	'care-my-jobs': React.lazy(() => import('~/features/care-my-jobs')),
	'care-jobs': React.lazy(() => import('~/features/care-jobs')),

	//RECRUITER FEATURES
	'recruiter-home': React.lazy(() => import('~/features/recruiter-home')),
	'recruiter-candidate-detail': React.lazy(() => import('~/features/recruiter-candidate-detail')),
	'recruiter-view-as-traveler': React.lazy(() => import('~/features/recruiter-view-as-traveler')),
	'recruiter-jobs': React.lazy(() => import('~/features/recruiter-jobs')),
	'recruiter-travelers': React.lazy(() => import('~/features/recruiter-travelers')),
	'recruiter-timecards': React.lazy(() => import('~/features/recruiter-timecards')),
	'recruiter-job-info': React.lazy(() => import('~/features/recruiter-job-info')),
	'recruiter-job-applicants': React.lazy(() => import('~/features/recruiter-job-applicants')),
	'recruiter-toas': React.lazy(() => import('~/features/recruiter-toas')),
	'recruiter-profile': React.lazy(() => import('~/features/recruiter-profile')),

	// COMMON FEATURES
	'common-sso': React.lazy(() => import('~/features/common-single-sign-on')),
	'common-salesforce-callback': React.lazy(() => import('~/features/common-salesforce-callback')),
	// "common-signin": React.lazy(() => import("~/features/common-signin")),
	'common-errors': React.lazy(() => import('~/features/common-errors')),
	'common-reset': React.lazy(() => import('~/features/common-reset')),
	'common-change-password': React.lazy(() => import('~/features/common-change-password')),
}
